<div
  class="chatbot-messages-body flex-grow-1 overflow-auto"
  ref="messages_body"
  @scroll.passive="handle_scroll"
  @click="handle_message_click"
>
  <div
    v-if="has_older_messages"
    class="d-flex justify-content-center py-2"
  >
    <button
      class="btn btn-outline-light btn-sm rounded-3 text-xs d-inline-flex align-items-center justify-content-center gap-1"
      :disabled="is_loading_older_messages"
      @click="$emit('load-older-messages')"
    >
      <i class="bi bi-arrow-up-circle"></i>
      <span>{{ is_loading_older_messages ? "Loading" : "Older messages" }}</span>
    </button>
  </div>

  <div
    v-for="(msg, index) in messages"
    :key="msg.id || 'msg-' + index"
    class="chatbot-message-row d-flex w-100"
    :class="msg.sender === 'user' ? 'justify-content-end' : 'justify-content-start'"
  >
    <div
      class="chatbot-message-group d-flex flex-column"
      :class="msg.sender === 'user' ? 'chatbot-message-group-user align-items-end' : 'chatbot-message-group-assistant align-items-start'"
    >
      <div
        v-if="msg.sender === 'user'"
        class="chatbot-bubble chatbot-bubble-user text-white p-2 rounded-3"
      >
        {{ msg.text }}
      </div>

      <div
        v-else
        class="chatbot-bubble chatbot-bubble-assistant text-white rounded-3"
        :class="msg.is_typing ? 'chatbot-bubble-thinking-shell p-0' : 'bg-white bg-opacity-10 p-2'"
      >
        <div v-if="msg.is_typing" class="chatbot-thinking" aria-label="VSI Assist is thinking">
          <div class="chatbot-thinking-header">
            <span class="chatbot-thinking-title">Working on your request</span>
            <span
              class="chatbot-thinking-status"
              :class="'chatbot-thinking-status-' + get_thinking_status(msg)"
            >
              {{ get_thinking_status_label(msg) }}
            </span>
          </div>

          <div class="chatbot-thinking-activity">
            <div
              v-for="(step, step_index) in msg.thinking_steps"
              :key="step.label || step_index"
              class="chatbot-thinking-step"
              :class="'chatbot-thinking-step-' + step.status"
            >
              <span class="chatbot-thinking-check" aria-hidden="true">
                <i v-if="step.status === 'complete'" class="bi bi-check-lg"></i>
                <i v-else-if="step.status === 'failed'" class="bi bi-x-lg"></i>
                <i v-else class="bi bi-arrow-repeat"></i>
              </span>
              <span class="chatbot-thinking-step-body">
                <span class="chatbot-thinking-step-label">{{ step.label }}</span>
                <span class="chatbot-thinking-step-detail">{{ step.detail }}</span>
              </span>
            </div>
          </div>
        </div>
        <div
          v-else
          class="d-block"
        >
          <div
            v-for="(block, block_index) in get_message_blocks(msg)"
            :key="block_index"
          >
            <strong
              v-if="block.type === 'heading'"
              class="chatbot-message-heading"
            >
              {{ block.text }}
            </strong>
            <template v-else>
              <template
                v-for="(part, part_index) in block.parts"
                :key="part_index"
              >
                <a
                  v-if="part.type === 'document'"
                  class="chatbot-message-document"
                  :href="part.href"
                  :data-download-href="part.href"
                  :title="part.href"
                >
                  <span class="chatbot-message-document-icon">
                    <i class="bi bi-file-earmark-pdf"></i>
                  </span>
                  <span class="chatbot-message-document-copy">
                    <span class="chatbot-message-document-title">{{ part.text }}</span>
                    <span class="chatbot-message-document-meta">PDF report</span>
                  </span>
                </a>
                <span
                  v-else-if="part.type === 'list_marker'"
                  class="chatbot-message-list-marker"
                >
                  {{ part.text }}
                </span>
                <strong
                  v-else-if="part.type === 'action_title'"
                  class="chatbot-message-action-title"
                >
                  {{ part.text }}
                </strong>
                <strong
                  v-else-if="part.type === 'strong'"
                  class="chatbot-message-strong"
                >
                  {{ part.text }}
                </strong>
                <em
                  v-else-if="part.type === 'emphasis'"
                  class="chatbot-message-emphasis"
                >
                  {{ part.text }}
                </em>
                <span v-else>{{ part.text }}</span>
              </template>
            </template>
          </div>
        </div>
      </div>

      <time
        v-if="format_message_timestamp(msg)"
        class="chatbot-message-timestamp"
        :datetime="get_message_created_at(msg)"
      >
        {{ format_message_timestamp(msg) }}
      </time>
    </div>
  </div>
</div>
